var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"select-tab"},_vm._l((_vm.tabs),function(item){return _c('li',{key:item.value,class:{
      'is-active': _vm.model === item.value,
    },on:{"click":function($event){$event.stopPropagation();return _vm.handleClick(item)}}},[_vm._v("\n    "+_vm._s(item.label)+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }